// extracted by mini-css-extract-plugin
module.exports = {"orderCard":"style_orderCard__JYGhA","title":"style_title__8yyD7","subtitle":"style_subtitle__3MmNT"};